/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_hub_mode2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`X is what percent of Y?`)
};

const es_pct_hub_mode2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué porcentaje es X de Y?`)
};

const de_pct_hub_mode2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viel Prozent von Y ist X?`)
};

const nl_pct_hub_mode2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`X is welk percentage van Y?`)
};

const fr_pct_hub_mode2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`X représente quel pourcentage de Y ?`)
};

const it_pct_hub_mode2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`X è quale percentuale di Y?`)
};

const pt_br2_pct_hub_mode2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`X é que porcentagem de Y?`)
};

const pt_pct_hub_mode2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`X é que percentagem de Y?`)
};

const ja_pct_hub_mode2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XはYの何パーセント？`)
};

const zh_pct_hub_mode2_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`X 是 Y 的百分之几？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_hub_mode2_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_hub_mode2_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_hub_mode2_title", locale)
	if (locale === "en") return en_pct_hub_mode2_title(inputs)
	if (locale === "es") return es_pct_hub_mode2_title(inputs)
	if (locale === "de") return de_pct_hub_mode2_title(inputs)
	if (locale === "nl") return nl_pct_hub_mode2_title(inputs)
	if (locale === "fr") return fr_pct_hub_mode2_title(inputs)
	if (locale === "it") return it_pct_hub_mode2_title(inputs)
	if (locale === "pt-BR") return pt_br2_pct_hub_mode2_title(inputs)
	if (locale === "pt") return pt_pct_hub_mode2_title(inputs)
	if (locale === "ja") return ja_pct_hub_mode2_title(inputs)
	return zh_pct_hub_mode2_title(inputs)
};